"use client"

import { AnonymousButton, MediaAttachmentButton, PlaneButton } from "@/components/Atoms/Buttons/ColorButtons"
import { useEffect, useState } from "react"
import { useRouter } from "next/navigation"
import Alert from "@/components/Atoms/Alerts/Alert"
import MentionInput from "@/components/Atoms/MentionTextArea"
import FileUploadDragAndDrop from "@/components/Atoms/FileUploadDragAndDrop"
/*
 handleCallback - fileupload
      if (cb.action === 'fileUpload') {setData({...data, file_name: standardizeFileName(cb.file.name), file_extension: cb.file.name.split('.')[1], file: cb.file})}


      handleSubmit 
        if (postPutData.file) {
    formData.append("file", postPutData.file, postPutData.file_name);
    formData.append("file_name", postPutData.file_name),
    formData.append("file_extension", postPutData.file_extension)
  }

  postputdata obj
    file: data?.file || null,
  file_name: data?.file_name,
  file_extension: data?.file_extension,
 */


const NewMessageCard = ({user, replyToUUID=false, parentPost, placeholder, parentComponent, callback}) => {

  // isNestedComment is a UUID of the comment we're commenting on
  const CHAR_LIMIT = 1000
  const router = useRouter()
  let query = null
  //  const blankDataInit = {
  //    id: 0,
  //    message_body: '',
  //    social_post_location_country: user?.user_location.country || '',
  //    social_post_location_state: user?.user_location.state || '',
  //    social_post_location_city: user?.user_location.city || '',
  //  }
     
  const socialPostDataInit = {
    parent_social_post_uuid: parentPost ? parentPost.social_post_uuid : '',
    parent_social_post_comment_uuid: replyToUUID ? replyToUUID : '',
    is_anonymous: false
    // message_body: replyToHandle ? `@${replyToHandle}` : ''
  }
     
     
  const [lang, setLang] = useState('en')
  //  const [messageData, setMessageData] = useState(parentPost ? {parent_social_post_uuid: parentPost.social_post_uuid} : '')
  const [messageData, setMessageData] = useState({...socialPostDataInit})
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [charLimitError, setCharLimitError] = useState(false)
  const [charCount, setCharCount] = useState(0)
  const [textAreaRows, setTextAreaRows] = useState(1)
  // const [user, setUser] = useState({...getCookies().user})
  const [loading, setLoading] = useState(false)



    useEffect(() => {

      // const textAreaHeight = document.getElementById('message_body')
      // setTextAreaRows(calculateTextAreaHeight(document.getElementById('message_body').value))
      // console.log("TEXTAREAHEIGHT", textAreaHeight.value)
      setMessageData(prev => ({
        ...prev,
        parent_social_post_uuid: parentPost?.social_post_uuid || '',
        parent_social_post_comment_uuid: replyToUUID || '',
        // message_body: replyToHandle ? `@${replyToHandle}` : ''
      }))
    }, [replyToUUID, parentPost])



    const calculateTextAreaRows = (str = "") => {
      const MIN_ROWS = 2
      const MAX_ROWS = parentComponent === 'SUBMISSIONS' ? 5 : 10 // if in thread (replying to post or comment), cap at 5. If new post, cap at 10.
      // Empty → reset
      if (str.length === 0) {
        setTextAreaRows(MIN_ROWS)
        return
      }

      const newLines = str.split("\n").length
      const lengthRows = Math.ceil(str.length / 100)

      const rows = Math.min(
        MAX_ROWS,
        Math.max(MIN_ROWS, Math.max(newLines, lengthRows))
      )

      setTextAreaRows(rows)
    }

    const handleChange = (event) => {
      // console.log(event.target.value.split("\n").length)
      // Ensure input is under char limit
      setCharCount(event.target.value?.length) // -replyToHandle.length
      if (event.target.value?.length >= CHAR_LIMIT) { // +replyToHandle.length
        setCharLimitError({message: 'Character limit exceeded'})
      }
      else {setCharLimitError(false)}

      calculateTextAreaRows(event.target.value)
    


    // if (event.target?.name ==='job_salary') {
    //   setSMData((prevData) => ({
    //     ...prevData,
    //     [event.target?.name]: event.target.value.replace(/\D/g, '')
    //   }));
    //   return;
    // }

    setMessageData((prevData) => ({
      ...prevData,
      [event.target?.name]: event.target?.value,
    }));
  
    // if(event.target?.value.length > 1){setMissingFields((prevMissingFields) => ({
    //   ...prevMissingFields,
    //   [event.target?.name]: false, // Mark the field as not missing
    // }));}
  };

  

    const handleSubmit = async () => {

    
      


      console.log("SUBMITDATA", messageData)

      setLoading(true)
      if (charLimitError) {
        setError({message: 'Character count exceeded'})
        setLoading(false)
        return;
      }


      const body = messageData.message_body?.trim();

      if (!body) {
        setError({ message: 'No text entered' });
        setLoading(false);
        return;
      }


      let target=null;
    callback({newMessage: messageData.message_body})
    setMessageData({...messageData, message_body: ''})
    router.refresh()
    setLoading(false)

      return; 

        try {
          // if (isNestedComment) {

          // }
          let apiUrl = target ? `/social/posts/?id=${target.id}&user_type=${user.user_type}` : `/api/social/posts/?user_type=${user.user_type}`
          let response = await fetch(apiUrl, {
          method: `${target ? 'PUT' : 'POST'}`, // Use uppercase for HTTP methods
          headers: {
            'Accept': '*/*',
            'Content-Type': 'application/json'
          },
          credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
          body: JSON.stringify({data: messageData, 
            // tags: {LEVEL_1: selectedLevel1Tags, LEVEL_2: selectedLevel2Tags, LEVEL_3: selectedLevel3Tags}, 
            user: user
          }), // Convert the credentials object to a JSON string
          // body: data
        });

        response = await response.json()
        console.log('handleSubmitResponse', response)

      if (response.success === true ) {
        setSuccess({message: 'Post / comment has been published.'})
        // callback({refreshData: true})
        // callback({resetTarget: true})
        setLoading(false)
        setMessageData({...messageData, message_body: ''})
        router.refresh()
      }
      else { 
        setError({message: `Could not publish the post / comment. Error: ${response.message}`})
        setLoading(false)
      }
      // callback({refreshData: true})

            
        } catch (error) {
          console.log('error', error)
            setError({message: `Could not publish the post / comment. Error: ${error}`})
          setLoading(false)
        }
  };

  return (
     <>
      <Alert state={{success: success, setSuccess: setSuccess, error: error, setError: setError}} message={success ? success.message : error ? error.message : ''}/>
     {/* <textarea rows={parentPost ? 3 : 10} placeholder={parentPost ? `Write a comment..` : `Share something..`} style={{resize:'none'}} className="mb-2 pb-12 dark:bg-transparent dark:border dark:border-slate-700 bg-slate-100 dark:text-white p-4 text-base font-inter text-black w-full rounded-xl" name="message_body" id="message_body" onChange={(x)=>handleChange(x)} value={messageData.message_body}/> */}


     <div className="relative w-full">
      {/* <TextAreaAutoGrow
        value={messageData.message_body}
        onChange={handleChange}
        /> */}

  <textarea
    // rows={parentPost ? 1 : 3}
    rows ={textAreaRows}
    placeholder={placeholder}
    style={{ resize: 'none' }}
    className={`
      w-full
      p-4
      pb-14
      text-base
      font-inter
      ${parentPost ? 'rounded' : 'rounded-xl'}
      bg-slate-100
      text-black
      dark:bg-slate-800
      dark:text-white
      dark:border
      dark:border-slate-700
      focus:outline-none
      dark:placeholder-slate-400
    `}
    name="message_body"
    id="message_body"
    onChange={handleChange}
    value={messageData.message_body}
  />

  {/* Send button */}
  <div>
    {/* <AnonymousButton toolTipCaption={'Anonymous'} loading={loading} isAnonymous={messageData.is_anonymous} onClick={() =>
    setMessageData(prev => ({
      ...prev,
      is_anonymous: !prev.is_anonymous
    }))
  } caption={'Post'}/>
<MediaAttachmentButton toolTipCaption={'Attach image (available soon)'} disabled={true} loading={loading} onClick={()=>handleSubmit()} caption={'Post'}/> */}
  <PlaneButton loading={loading} onClick={()=>{handleSubmit()}} caption={'Post'}/>
    <div className="absolute top-2 right-6 flex items-center justify-center h-9 w-9 rounded-full text-slate-500 hover:text-teal-400  transition">
      <p className={`text-xs mb-2 text-right ${charLimitError && 'text-red-500'} text-slate-300`}>{charCount}/{CHAR_LIMIT}</p>
    </div>
    </div>
</div>


     {/* <MentionInput  onChange={(x)=>handleChange(x)} value={messageData.message_body}/> */}

      {/* <p className={`text-xs mb-2 text-right ${charLimitError && 'text-red-500'} text-slate-300`}>{charCount}/{CHAR_LIMIT}</p> */}
      {/* <TealButton loading={loading} onClick={()=>handleSubmit()} caption={'Post'}/> */}
      </>
  )
}

export default NewMessageCard